/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DefaultPeriodConfig } from './DefaultPeriodConfig';
import {
    DefaultPeriodConfigFromJSON,
    DefaultPeriodConfigFromJSONTyped,
    DefaultPeriodConfigToJSON,
} from './DefaultPeriodConfig';
import type { RawFilter } from './RawFilter';
import {
    RawFilterFromJSON,
    RawFilterFromJSONTyped,
    RawFilterToJSON,
} from './RawFilter';
import type { ReadFilter } from './ReadFilter';
import {
    ReadFilterFromJSON,
    ReadFilterFromJSONTyped,
    ReadFilterToJSON,
} from './ReadFilter';

/**
 * 
 * @export
 * @interface BackfillConfig
 */
export interface BackfillConfig {
    /**
     * 
     * @type {DefaultPeriodConfig}
     * @memberof BackfillConfig
     */
    defaultPeriod: DefaultPeriodConfig;
    /**
     * Filters to apply only during backfill. Multiple conditions are joined by AND. Use this when you want different filter behavior for backfill vs. incremental reads.
     * @type {Array<ReadFilter>}
     * @memberof BackfillConfig
     */
    fieldFilters?: Array<ReadFilter>;
    /**
     * 
     * @type {RawFilter}
     * @memberof BackfillConfig
     */
    rawFilter?: RawFilter;
}

/**
 * Check if a given object implements the BackfillConfig interface.
 */
export function instanceOfBackfillConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "defaultPeriod" in value;

    return isInstance;
}

export function BackfillConfigFromJSON(json: any): BackfillConfig {
    return BackfillConfigFromJSONTyped(json, false);
}

export function BackfillConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackfillConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultPeriod': DefaultPeriodConfigFromJSON(json['defaultPeriod']),
        'fieldFilters': !exists(json, 'fieldFilters') ? undefined : ((json['fieldFilters'] as Array<any>).map(ReadFilterFromJSON)),
        'rawFilter': !exists(json, 'rawFilter') ? undefined : RawFilterFromJSON(json['rawFilter']),
    };
}

export function BackfillConfigToJSON(value?: BackfillConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'defaultPeriod': DefaultPeriodConfigToJSON(value.defaultPeriod),
        'fieldFilters': value.fieldFilters === undefined ? undefined : ((value.fieldFilters as Array<any>).map(ReadFilterToJSON)),
        'rawFilter': RawFilterToJSON(value.rawFilter),
    };
}

